// extracted by mini-css-extract-plugin
module.exports = {"selected":"MenuItem-module--selected--2WZRf","unselected":"MenuItem-module--unselected--3cbIG"};